<template>
  <section
    class="section-default bg-light2"
    :class="{
      'right': right,
      'shorter': shorter,
      'mobile-revers': mobileRevers
    }">
    <template v-if="mobileRevers">
      <div class="container container-small"
           v-for="(section, index) in headers"
           :key="'first' + index">
        <template v-if="index === 0">
          <transition name="text">
            <TextSection
              v-if="visible || mobile"
              :header="section.header"
              :description="section.description"
              :caption="section.caption"
              :smaller="section.smaller"
              :italic="true" />
          </transition>
        </template>
      </div>
      <div class="container container-small">
        <transition name="text">
          <template v-for="(section, index) in headers">
            <TextSection
              v-if="(visible || mobile) && index !== 0"
              :key="index"
              :header="section.header"
              :description="section.description"
              :caption="section.caption"
              :smaller="section.smaller"
            />
          </template>
        </transition>
        <TextSlider v-if="items" :items="items" class="text-m"/>
        <ScrollTo v-if="scrollTop" :dark="true" :top="true" :where="0" speed="2500"/>
      </div>
      <transition name="pulse">
        <div class="bcg"
             :class="{'bcg-visible' : visible}"
             :style="{'background-image': (imageAnimation ? 'none' : 'url('+image+')') }">
          <AnimatedImage v-if="imageAnimation" :id="imageAnimation" :visible="visible" />
          <img v-else :src="image" alt="Section image" />
        </div>
      </transition>
    </template>
    <template v-else>
      <transition name="pulse">
        <div class="bcg"
            :class="{'bcg-visible' : visible && right}"
            :style="{'background-image': (imageAnimation ? 'none' : 'url('+image+')') }">
          <AnimatedImage v-if="imageAnimation" :id="imageAnimation" :visible="visible" />
          <img v-else :src="image" alt="Section image" />
        </div>
      </transition>
      <div class="container container-small">
        <transition name="text" v-for="(section, index) in headers" :key="index">
          <TextSection
            v-if="visible || mobile"
            :header="section.header"
            :description="section.description"
            :caption="section.caption"
            :smaller="section.smaller"
            :cutLengthTextBig="400" />
        </transition>
        <TextSlider v-if="items" :items="items" class="text-m"/>
        <ScrollTo v-if="scrollTop" :dark="true" :top="true" :where="0" speed="2500"/>
      </div>
    </template>
  </section>
</template>

<script>
import TextSection from '@/components/TextSection.vue'
import ScrollTo from '@/components/ScrollTo.vue'
import TextSlider from '@/components/TextSlider.vue'
import AnimatedImage from '@/components/AnimatedImage.vue'

export default {
  name: 'defaultSection',
  props: [ 'right', 'headers', 'image', 'imageAnimation', 'shorter', 'mobileRevers', 'scrollTop', 'visible', 'mobile', 'items' ],
  components: {
    TextSection,
    ScrollTo,
    TextSlider,
    AnimatedImage
  },
  methods: {
    showNext () {
      if (!this.items) { return false }
      this.activeItem = this.activeItem + 1 < this.items.length
        ? Math.min(this.activeItem + 1, this.items.length - 1)
        : 0
      this.loop = false
      window.clearTimeout(this.loopTimeout)
    },
    loopNext () {
      if (this.loop && this.items) {
        this.activeItem = this.activeItem + 1 < this.items.length
          ? Math.min(this.activeItem + 1, this.items.length - 1)
          : 0
        this.loopTimeout = window.setTimeout(() => {
          this.loopNext()
        }, 4000)
      }
    },
    showPrev () {
      if (!this.items) { return false }
      this.activeItem = this.activeItem - 1 >= 0
        ? Math.max(this.activeItem - 1, 0)
        : this.items.length - 1
      this.loop = false
      window.clearTimeout(this.loopTimeout)
    }
  },
  mounted () {
    setTimeout(this.loopNext, 10000)
  }
}
</script>

<style scoped lang="scss">
  .section-default {
    padding: 0;
    min-height: 680px;
    @include desktop-small {
      min-height: 400px;
    }

      .slider {
        bottom: 0 !important;
        margin-top: 5em;
        position: relative;
      }

      @include tablet {
        h2 {
          max-width: 100%;
        }
        .parts-wrapper {
          width: 100%;
        }
      }
    &.about-section {
      .parts-wrapper {
        margin-bottom: 4em;
        // min-height: 245px;
        // @include tablet {
        //   min-height: 180px;
        // }
        // @include mobile {
        //   min-height: 310px;
        // }
      }
    } // END .section-default.about-section;
  }
  header {
    width: 300px;
    max-width: 90vw;
  }
  .bcg {
    background-repeat: no-repeat;
    background-position: right center;
    background-size: auto 100%;
    position: absolute;
    width: 69vw;
    min-height: 100%;
    height: 100%;
    right: 0;
    top: 0;
    display: flex;
    visibility: hidden;

    &-visible {
      visibility: visible;
    } // END .bcg-visible;

    img {
      max-height: 100%;
      max-width: 100%;
      align-self: flex-end;
      display: none;
    }
    .right & {
      right: auto;
      background-position: left center;
      left: 0;
    }
    .shorter & {
      background-size: auto 100%;
      background-position: 10% bottom;
      padding-top: 20px;
      @include desktop-big {
        background-size: auto 90%;
        background-position: left bottom;
      }
      @include desktop {
        width: 55vw;
        background-size: auto 80%;
        background-position: right bottom;
      }
      @include desktop-small {
        background-position: right bottom;
      }
    }
    z-index: 0;
    @include desktop-small {
      width: 51vw;
      background-position: right bottom;
      background-size: contain;
    }
    @include tablet {
      .shorter & {
        width: 100%;
        display: block;
        position: static;
        background-image: none !important;
        background-position: center;
        height: auto;
        .right & {
          background-position: center;
        }
        img {
          display: block;
          width: 100%;
          max-height: 100vh;
        }
      }
    }
    @include mobile {
      width: 100%;
      display: block;
      position: static;
      background-image: none !important;
      background-position: center;
      height: auto;
      .right & {
        background-position: center;
      }
      img {
        display: block;
        width: 100%;
        max-height: 100vh;
      }
    }
  }
  section {
    position: relative;
    // min-height: 600px;
    padding: 0 0;
    .container {
      position: relative;
      padding: 113px 42vw 1px 0;
    }
    &.shorter {
      .container {
        padding: 113px 42vw 1px 0;
      }
    }
    &.right {
      .container {
        padding: 60px 0 1px 39vw;
      }
      &.shorter {
        .container {
          padding: 113px 0 1px 39vw;
        }
      }
    }
    @include desktop {
      &.right {
        .container {
          padding: 60px 0 1px 48vw;
        }
        &.shorter {
          .container {
            padding: 113px 0 1px 48vw;
          }
        }
      }
    }
    @include tablet {
      &.right {
        .container {
          padding: 1px 0 1px 48vw;
        }
        &.shorter {
          .container {
            padding: 60px 0 35px 0;
          }
        }
      }
    }
    @include mobile {
      .container {
        padding: 60px 0 0 0;
      }
      &.right {
        .container {
          padding: 60px 0 35px 0;
        }
        &.shorter {
          .container {
            padding: 60px 0 35px 0;
          }
        }
      }
    }
    .font-size-l & {
      @include mobile {
        .bcg {
          width: 100%;
        }
      }
      @include screen('lg') {
        .bcg {
          width: 45vw;
        }
      }
    }
    &.mobile-revers {
      .container:not(:first-child) {
        padding-top: 0 !important;
        @include tablet {
          padding-top: 60px !important;
        }
      }
      .bcg {
        width: 50vw;
      }
      @include desktop-small {
        .bcg {
          background-size: cover;
        }
      }
      @include tablet {
        .bcg {
          width: 100%;
          display: block;
          position: static;
          background-image: none !important;
          background-position: center;
          height: auto;
          .right & {
            background-position: center;
          }
          img {
            display: block;
            width: 100%;
            max-height: 100vh;
          }
        }
        .container {
          padding: 60px 0 35px 0;
        }
      }
    }
  }
</style>
